import type { ItineraryCardTagsProps } from './ItineraryCard.types';
import styles from './ItineraryCardTags.module.css';

export function ItineraryCardTags({ tags }: ItineraryCardTagsProps) {
  if (tags.length === 0) return null;

  return (
    <ul className={styles.list}>
      {tags.map(({ label, variant = 'default', icon }) => (
        <li key={label} className={`${styles.tag} ${styles[variant]}`}>
          {icon && (
            <span className={styles.tagIcon} aria-hidden="true">
              {icon}
            </span>
          )}
          <span>{label}</span>
        </li>
      ))}
    </ul>
  );
}
